import { Eyebrow, MaskLines } from "@/components/site/Motion";

export const PageHeader = ({ eyebrow, title, children, testid }) => (
  <section className="grain relative overflow-hidden border-b border-white/10 pt-[130px] pb-14" data-testid={testid}>
    <div aria-hidden className="pointer-events-none absolute -left-32 top-0 h-[380px] w-[380px] rounded-full bg-violet/30 blur-[130px]" />
    <div aria-hidden className="pointer-events-none absolute right-0 top-20 h-[300px] w-[300px] rounded-full bg-flash/15 blur-[130px]" />
    <div className="relative mx-auto max-w-[1400px] px-5 sm:px-8">
      {eyebrow && <Eyebrow>{eyebrow}</Eyebrow>}
      <h1 className="mt-5 font-display text-5xl font-extrabold leading-[0.92] tracking-[-0.03em] sm:text-7xl">
        <MaskLines lines={Array.isArray(title) ? title : [title]} />
      </h1>
      {children}
    </div>
  </section>
);
